import React, { useState, useEffect  } from "react";
import { useParams } from 'react-router-dom';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import configVars from "../../config";
import CheckoutForm from "./CheckoutForm";
import validator from "validator";
import { useTranslation } from "react-i18next";

const stripePromise = loadStripe("pk_live_RDZ9oLYo1JTFmuTXQBGgFD7F");

const MembershipPlan = ( props ) => {

    const { plan, type, pstatus } = useParams();
    const [clientSecret, setClientSecret] = useState("");
    // const [planPrice, setPlanPrice] = useState(0);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [translation] = useTranslation("translations");
    const [step, setStep] = useState('info');
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const [couponVal, setCouponVal] = useState(0);
    const [couponID, setCouponID] = useState('');
    const [isTrial, setIsTrial] = useState(false);

    useEffect(() => {

        if ( pstatus ) {
            setStep('payment');

            let clientSecret = new URLSearchParams(window.location.search).get(
                "payment_intent_client_secret"
            );

            if (!clientSecret) {

                clientSecret = new URLSearchParams(window.location.search).get(
                    "setup_intent_client_secret"
                );
            }

            if ( clientSecret ) {
                setClientSecret(clientSecret);
            }
        }

        const couponID = new URLSearchParams(window.location.search).get('c');

        if ( couponID && !pstatus ) {

            setCouponID( couponID );
            
            (async () => {
                
                setIsLoading(true);

                let userRequestData = new FormData();
                userRequestData.append( 'coupon_id', couponID );

                const fetchUrl = `${configVars.apiUrl}sustainchange/v1/getcoupondata/`;

                try{

                    const response = await fetch(
                        fetchUrl,
                        {
                        method: "POST",
                        headers: {
                            Authorization: `Basic ${configVars.auth}`,
                        },
                        body: userRequestData
                        }
                    );
                    
                    const couponResponse = await response.json();
            
                    if ( couponResponse ) {
                        
                        if ( couponResponse.success === true ) {
                            
                            if ( couponResponse.data.coupon_data.valid === true ) {
                                setCouponVal( parseInt( couponResponse.data.coupon_data.percent_off, 10 ));
                            }

                        } else {
                            setIsError(true);
                            setErrorMsg('Invalid Coupon.');
                        }

                    }

                } catch( error ) {
                    console.log( error );
                    return error;
                }

                setIsLoading(false);
    
            })()

        }

    }, [pstatus]);

    const calculatePrices = ( selectedPlan ) => {

        if ( !selectedPlan ) return;

        let planPrice = 0;

        const monthlyPrice = selectedPlan?.sy_membership_price_monthly;
        const yearlyPrice = selectedPlan?.sy_membership_price_yearly;

        if ( type === 'monthly' ) {
            planPrice = parseInt( ( monthlyPrice * 1.25 ), 10 );
        } else {
            planPrice = parseInt( ( yearlyPrice * 1.25 ), 10 );
        }

        if (couponVal && couponVal > 0 ) {
            planPrice = (planPrice * (100 - couponVal))/100;
            planPrice = planPrice.toFixed(0);
        }


        return planPrice;

    }

    const createSubscription = async () => {

		const validation = handleValidation( firstName, lastName, userEmail);

		if ( ! validation.isValidated ) {
			//setMessage( validation.validationMsg );
			return;
		}

		setIsLoading(true);
        setIsError( false );
        setErrorMsg( '' );

		const fullName = `${firstName} ${lastName}`;

		const response = await fetch(
			`${configVars.apiUrl}sustainchange/v1/stripecreatesubscription/?email=${encodeURIComponent(userEmail)}&name=${encodeURIComponent(fullName)}&plan=${plan}&type=${type}&coupon=${couponID}`,
			{
				method: "GET",
				headers: {
					Authorization: `Basic ${configVars.auth}`,
				},
			}
		);

		const customerResponse = await response.json();

		if ( customerResponse ) {

			//console.log( customerResponse );

            if ( customerResponse.success === true ) {

                setClientSecret(customerResponse.data.client_secret );
                setStep('payment');

                if ( customerResponse.data.free_trial === true ) {
                    setIsTrial(true);
                }

            } else {
                setIsError( true );
                setErrorMsg( customerResponse.message );
            }

            
			
		}

		setIsLoading(false);
	}

    const handleValidation = (firstName, lastName, email) => {

        let isValidated = true;
        let validationMsg = '';

        if ( ! firstName.toString().trim().length || ! lastName.toString().trim().length || ! email.toString().trim().length ) {
            isValidated = false;
            validationMsg = translation("fill_required_fields");
        }

        if ( !validator.isEmail(email) ) {
            isValidated = false;
            validationMsg = translation("enter_valid_email");
        }

        return {
            'isValidated' : isValidated,
            'validationMsg': validationMsg
        }

    }

    const appearance = {
        theme: 'stripe',
    };
    
    const options = {
        clientSecret,
        appearance,
    };

    return (
        <div className="payment-wrap py-5">
            <div className="row">
                <div className="col-12 col-lg-7">
                    <div className="d-flex flex-column mb-4 mb-lg-0">
                        <span className="h3">
                            <strong>Typ av prenumeration: </strong>
                            {props.selectedPlan?.sy_membership_name}
                        </span>
                        <span className="h3">
                            <strong>Förnyelseperiod: </strong>
                            {translation(type)}
                        </span>

                        { pstatus !== 'complete' &&
                            <span className="h3">
                                <strong>Belopp: </strong>
                                { isLoading &&
                                    <div className="spinner-border ms-2 spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                }

                                { !isLoading &&
                                    <>
                                        { calculatePrices( props.selectedPlan ) } SEK
                                        { props.selectedPlan?.sy_membership_type === 'private' ? ' (inkl moms)' : ' (exkl moms)' }
                                    </>
                                }
                            </span>
                        }

                    </div>
                </div>
                <div className="col-12 col-lg-5">
                    { isError &&
                        <div className="alert alert-danger" role="alert">
                            { errorMsg }
                        </div>
                    }

                    {step === 'info' && !pstatus &&
                        <div className="user-info-step">
                            <div className="row mb-3">
                                <div className="col-12 col-lg-6">
                                    <label htmlFor="first_name" className="form-label">Förnamn</label>
                                    <input type="text" className="form-control" name="first_name" id="first_name" placeholder="Ditt förnamn" value={firstName} onChange={ (e) => setFirstName( e.target.value) } />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <label htmlFor="last_name" className="form-label">Efternamn</label>
                                    <input type="text" className="form-control" name="last_name" id="last_name" placeholder="Ditt efternamn" value={lastName} onChange={ (e) => setLastName( e.target.value) } />
                                </div>
                            </div>
                            <div className="row mb-3">
                                    <div className="col-12">
                                        <label htmlFor="user_email" className="form-label">Mailadress</label>
                                        <input type="email" className="form-control" id="user_email" placeholder="Din mailadress" value={userEmail} onChange={ (e) => setUserEmail( e.target.value) } />
                                    </div>
                                </div>

                            <button type="button" className="btn btn-secondary" onClick={() => createSubscription()}>
                                <span>Starta prenumeration</span>
                                {isLoading &&
                                    <div className="spinner-border text-white ms-2 spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                }
                            </button>
                        </div>
                    }

                    {step === 'payment' && clientSecret && (
                        <Elements options={options} stripe={stripePromise}>
                            <CheckoutForm pstatus={pstatus} isTrial={isTrial} />
                        </Elements>
                    )}
                </div>
            </div>
        </div>
    );

}

export default MembershipPlan;